export default __webpack_public_path__ + "static/media/placeholder_dummy2016-psychotherapie01-de.ed122409.png";